import React, { useEffect, useState } from 'react'
import { PrimaryButton, SecondaryButton } from "../UI";
import { sendResetPasswordEmail } from '../../utils/APIs';
import SuccessAlert from '../UI/Alert/SuccessAlert';
import ErrorAlert from '../UI/Alert/ErrorAlert';
import Loader from '../UI/Loader/Loader';
import { useContentfulContext } from '../../contexts/ContentfulContext';
import { ANALYTICS_EVENTS } from '../../constants/analyticsEvents';
import { useUserContext } from '../../contexts/UserContext';

const UpdatePassword = ({ setShowUpdatePassword, selectedUser }) => {
    // const { userData } = useUserContext();
    const { content } = useContentfulContext();
    const { userData } = useUserContext();
    const [pwdSuccess] = useState(false);
    // const [pwdOption] = useState('generate-password');
    const [createPwd] = useState('');
    const [, setGeneratePwd] = useState('');
    const [, setPwdValid] = useState(true);
    const [, setPwdErrorMsg] = useState('');
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false)
    const generatePassword = () => {
        let charset = "";
        let newPassword = "";
        const passwordLength = 12;
        charset += "!@#$%^&*()";
        charset += "0123456789";
        charset += "abcdefghijklmnopqrstuvwxyz";
        charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for (let i = 0; i < passwordLength; i++) {
            newPassword += charset.charAt(
                Math.floor(Math.random() * charset.length)
            );
        }
        setGeneratePwd(newPassword);
    };

    const validatePasswordRules = () => {
        if(createPwd.length == 0) {
            setPwdValid(false);
            setPwdErrorMsg('Enter a password');
        } else if(!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/.test(createPwd)) {
            setPwdValid(false);
            setPwdErrorMsg('Password must contains 1 upper case letter, 1 lower case letter, 1 numeric digit');
        } else {
            setPwdValid(true);
        }
    }

    // const validatePasswordHandler = () => {
    //     if(pwdOption == 'create-password') {
    //         if(pwdValid && createPwd) {
    //             setPwdSuccess(true);
    //         } else {
    //             validatePasswordRules();
    //         }
    //     } else {
    //         setPwdSuccess(true);
    //     }
    // }

    const handleResetPassword = async () => { 
        setLoading(true)
        try {
            const result = await sendResetPasswordEmail(selectedUser?.email, userData?.selectedOrganization?.org_token, {
                                event_name: ANALYTICS_EVENTS.RESET_PASSWORD,
                                metadata: { email: selectedUser?.email }
                              });
            result && setLoading(false)
            setSuccessMessage(result?.message);
        } catch (error) {
            setLoading(false)
            console.log('error', error);
            setErrorMessage(error?.response?.data?.message || error?.message)
        }
    }

    useEffect(() => {
        validatePasswordRules();
    }, [createPwd]);

    useEffect(() => {
        generatePassword();
    }, []);

    return (
        <>
            {loading && <Loader/>}
            {!pwdSuccess && <>
                <div className="p-6 text-left">
                    <a href="#" className="font-medium text-primary hover:underline flex items-center mb-4" onClick={(e) => {
                        e.preventDefault();
                        setShowUpdatePassword(false);
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" className="injected-svg fill-current mr-2"><line x1="8.75" y1="12" x2="17.25" y2="12" stroke="white" strokeWidth="1.5" strokeLinecap="round"></line><path fillRule="evenodd" clipRule="evenodd" d="M11.5302 4.53033C11.8231 4.23744 11.8231 3.76256 11.5302 3.46967C11.2373 3.17678 10.7624 3.17678 10.4695 3.46967L3.17663 10.7626C2.49321 11.446 2.49321 12.554 3.17663 13.2374L10.4695 20.5303C10.7624 20.8232 11.2373 20.8232 11.5302 20.5303C11.8231 20.2374 11.8231 19.7626 11.5302 19.4697L4.81051 12.75H21.2499C21.6641 12.75 21.9999 12.4142 21.9999 12C21.9999 11.5858 21.6641 11.25 21.2499 11.25H4.81051L11.5302 4.53033Z"></path></svg> {content.UPDATE_PASSWORD_MODAL.reset_password.instruction_text.back_cta_text}
                    </a>
                    <h2 className="text-xl font-bold leading-tight tracking-tight text-black text-left mb-2">{content.UPDATE_PASSWORD_MODAL.reset_password.title}</h2>
                    <p className='text-base leading-tight tracking-tight text-black mb-4'>{content.UPDATE_PASSWORD_MODAL.reset_password.description}</p>
                </div>
                <div className="flex items-center justify-end p-6 space-x-2">
                    <PrimaryButton handleClick={handleResetPassword}>{content.UPDATE_PASSWORD_MODAL.reset_password.instruction_text.reset_cta_text}</PrimaryButton>
                </div>
            </>}
            { successMessage && <SuccessAlert disappearTime={5000} >{successMessage}</SuccessAlert> }
            { errorMessage && <ErrorAlert timeout={5000}>{errorMessage}</ErrorAlert>}
            {pwdSuccess && <>
                <div className="p-6 pb-0 text-left">
                    <h2 className="text-xl font-bold leading-tight tracking-tight text-black text-left mb-2">{content.UPDATE_PASSWORD_MODAL.password_successful.title}</h2>
                    <p className='text-base leading-tight tracking-tight text-black mb-4'>{content.UPDATE_PASSWORD_MODAL.password_successful.description}</p>
                </div>
                <div className="flex items-center justify-between p-6 space-x-2">
                    <SecondaryButton type="button">{content.UPDATE_PASSWORD_MODAL.password_successful.instruction_text.send_email_cta_text}</SecondaryButton>
                    <PrimaryButton type="button" handleClick={() => { setShowUpdatePassword(false) }}>{content.UPDATE_PASSWORD_MODAL.password_successful.instruction_text.done_cta_text}</PrimaryButton>
                </div>
            </>}
        </>
    )
}

export default UpdatePassword;